import type { AuthoredEntityOrSingleSchema } from '@cli-types/core-engine/add-field.js'
import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { readSchemaSlotFields } from './read-schema-slot-fields.js'

export function getAuthoredSchemaRootFields(schema: AuthoredEntityOrSingleSchema): SchemaField[] {
  return schema.slot ? readSchemaSlotFields(schema.slot) : (schema.fields ?? [])
}
